// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "core-js/es6/promise";
import "core-js/es6/string";
import "core-js/es7/array";
// import cssVars from 'css-vars-ponyfill'
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import App from "./App";
import router from "./router";
import VueLocalStorage from "vue-localstorage";
import moment from "moment";
import { store } from "./store";
import AirbnbStyleDatepicker from "vue-airbnb-style-datepicker";
import "vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css";
const datepickerOptions = {};
import Toasted from "vue-toasted";
// todo
// cssVars()

Vue.use(BootstrapVue);
Vue.use(VueLocalStorage);
Vue.use(Toasted);
Vue.use(AirbnbStyleDatepicker, datepickerOptions);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: {
    App,
  },
});

Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY");
  }
});

Vue.filter("formatSlug", function (value) {
  if (value) {
    let final = value.replace(/-/g, " ");
    final = final.charAt(0).toUpperCase() + final.substr(1);
    return final;
  }
});

Vue.filter("roundAverage", function (value) {
  if (value) {
    return value.toFixed(1);
  }
});

Vue.filter("formatNumber", function (value) {
  if (value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
});
